import React from "react";
import { Box, TextField, Typography, Button, Paper } from "@mui/material";
import { useTheme } from "@emotion/react";

export default function StepOne({
  plate,
  phone,
  setPlate,
  setPhone,
  onNext,
  errors,
}) {
  const handlePlateChange = (e) => {
    const cleaned = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    setPlate(cleaned);
  };
  const theme = useTheme();

  const handlePhoneChange = (e) => {
    const cleaned = e.target.value.replace(/[^0-9]/g, "");
    setPhone(cleaned);
  };

  return (
    <Box display="flex" flexDirection="column" gap={4}>
      {/* Header box */}
      <Paper
        elevation={1}
        sx={{
          p: 3,
          backgroundColor:
            theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
        }}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          color={theme.palette.mode === "dark" ? "#fff" : "#1e3a8a"}
        >
          Iniziamo!
        </Typography>
        <Typography
          variant="body2"
          color={theme.palette.mode === "dark" ? "#fff" : "#1e3a8a"}
        >
          Inserisci i dati del veicolo per procedere.
        </Typography>
      </Paper>

      {/* Plate input */}
      <Box>
        <Typography variant="body2" fontWeight="600" mb={1}>
          Targa Veicolo *
        </Typography>

        {/* Wrapper simile al tuo layout */}
        <Box
          position="relative"
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* Left blue strip */}
          <Box
            sx={{
              width: 32,
              backgroundColor: "#1d4ed8",
              borderRadius: "8px 0 0 8px",
              color: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "10px",
              fontWeight: "bold",
              position: "absolute",
              left: 0,
              top: 0,
              bottom: 0,
              zIndex: 10,
            }}
          >
            <Box
              sx={{
                border: "2px solid white",
                borderRadius: "50%",
                width: 20,
                height: 20,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "8px",
                mb: 0.5,
              }}
            >
              I
            </Box>
          </Box>

          <TextField
            fullWidth
            value={plate}
            onChange={handlePlateChange}
            placeholder="AB123CD"
            inputProps={{
              maxLength: 7,
              style: {
                textTransform: "uppercase",
                fontFamily: "monospace",
                letterSpacing: "4px",
                paddingLeft: "40px",
              },
            }}
            error={Boolean(errors.plate)}
            helperText={errors.plate}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          />

          {/* Right blue strip */}
          <Box
            sx={{
              width: 32,
              backgroundColor: "#1d4ed8",
              borderRadius: "0 8px 8px 0",
              position: "absolute",
              right: 0,
              top: 0,
              bottom: 0,
              zIndex: 10,
            }}
          />
        </Box>
      </Box>

      {/* Phone input */}
      <Box>
        <Typography variant="body2" fontWeight="600" mb={1}>
          Cellulare *
        </Typography>
        <TextField
          fullWidth
          value={phone}
          onChange={handlePhoneChange}
          placeholder="333 1234567"
          error={Boolean(errors.phone)}
          helperText={errors.phone}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
            },
          }}
        />
      </Box>

      {/* Bottom button */}
      <Box
        sx={{
          bottom: { xs: 0 },
          left: 0,
          right: 0,
          p: { xs: 2, lg: 0 },
          borderTop: { xs: "1px solid #e5e7eb", lg: "0" },
        }}
      >
        <Button
          fullWidth
          variant="contained"
          onClick={onNext}
          sx={{
            py: 2,
            fontSize: "1.1rem",
            borderRadius: "10px",
          }}
        >
          Continua
        </Button>
      </Box>

      {/* Spacer for mobile sticky button */}
      <Box height={{ xs: 80, lg: 0 }} />
    </Box>
  );
}
